import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Panel } from '../components/primitives/Panel';
import { SMLThemeSwitch } from '../components/SMLThemeSwitch';
import { Music24FullLogo } from '../components/Music24FullLogo';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole consent page; each part uses its own slice of it */
import styles from './OAuthConsentView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface OAuthConsentPageProps {
  /** Loading or error: the card centres its content. */
  isState?: boolean;
}

/**
 * The page around the consent card (design: oauth-consent a1, `.oc-page`): a full page with no
 * sidebar, as the sign-in page. The top bar has the brand and the theme switch, the card is one Panel.
 */
const OAuthConsentPageComponent: React.FC<React.PropsWithChildren<OAuthConsentPageProps>> = ({
  children,
  isState = false,
}) => (
  <div className={styles.page}>
    <header className={styles.top}>
      <span className={styles.brand}>
        <Music24FullLogo size={26} />
      </span>
      <SMLThemeSwitch variant="icon" direction="down" align="end" />
    </header>
    <main className={styles.main}>
      <Panel className={clsx(styles.card, isState && styles.state)}>{children}</Panel>
    </main>
  </div>
);

export const OAuthConsentPage = TypedMemo(OAuthConsentPageComponent);
